import axios from 'axios';

// If enable, then it will load static data. Otherwise, it will load from remote backend.
// Currently, it does not support remote backend mode. 
const ENABLE_STATIC_JSON = true;
export const ENABLE_FORCE_AUTH = false;
// Remote Backend.
const URL = process.env.NODE_ENV === 'development'
    ? 'http://localhost:7777'
    : window.location.origin;
const axiosInstance1 = axios.create({
    baseURL: `${URL}/api/`,
    // timeout: 1000,
    headers: {
        'Access-Control-Allow-Origin': '*'
    }
});

// Load Static Data.
const URL2 = window.location.href;
//const URL2 = window.location.origin;
const axiosInstance2 = axios.create({
    baseURL: `${URL2}/data/`,
    // timeout: 1000,
    headers: {
        'Access-Control-Allow-Origin': '*'
    }
});

let axiosInstance = (ENABLE_STATIC_JSON)?axiosInstance2:axiosInstance1;
let TOKEN:any = "";


// Read graph dataset metainfo.
export async function getUserVerify(username: any, password:any): Promise<any> {
    let url = `/user_verify`;
    const params = { username, password};
    const res = await axiosInstance.get(url, {params}); // EXCEPTION
    //const params = { classifier_start, classifier_end };
    if (res.status === 200) {
        return res.data;
    }
    throw res;
}
function wrap_params_with_token(params: any){
    if(ENABLE_FORCE_AUTH){
        const new_params:any = {
            token: TOKEN,
            ...params
        };
        return new_params;
    }else{
        return params;
    }
    
    
    
}
export function setToken(token:any) {
    TOKEN = token;
}

// Read graph dataset metainfo.
export async function getData(): Promise<any> {
    let url = `/data`;
    if(ENABLE_STATIC_JSON){
        url = '/data.json'
    }
    //const params = { classifier_start, classifier_end };
    const params = wrap_params_with_token({});

    const res = await axiosInstance.get(url, {params});
    if (res.status === 200) {
        return res.data;
    }
    throw res;
}

// Read graph dataset metainfo.
export async function getExploreMetaData(): Promise<any> {
    let url = `/explore`;
    if(ENABLE_STATIC_JSON){
        url = '/explore.json'
    }
    //const params = { classifier_start, classifier_end };
    const params = wrap_params_with_token({});

    const res = await axiosInstance.get(url, {params});
    if (res.status === 200) {
        return res.data;
    }
    throw res;
}
export async function getExploreIndividualData(dataset:any="PASCAL"): Promise<any> {
    let url = `/` + dataset + "/explore_" + dataset + ".json";
    if(ENABLE_STATIC_JSON){
        url = `/` + dataset + "/explore_" + dataset + ".json";
    }
    //const params = { classifier_start, classifier_end };
    const params = wrap_params_with_token({});

    const res = await axiosInstance.get(url, {params});
    if (res.status === 200) {
        return res.data;
    }
    throw res;
}
// Read graph dataset metainfo.
export async function getRawData(dataset:any="PASCAL", filename="2008_000348.jpg"): Promise<any> {
    let url = `/` + dataset + "/" + filename;
    if(ENABLE_STATIC_JSON){
        url = `/` + dataset + "/" + filename;
    }
    //const params = { classifier_start, classifier_end };
    const params = wrap_params_with_token({});

    const res = await axiosInstance.get(url, {params});
    if (res.status === 200) {
        return res.data;
    }
    throw res;
}

// Read graph dataset metainfo.
export async function getDatasetList(): Promise<any> {
    let url = `/datasets`;
    if(ENABLE_STATIC_JSON){
        url = '/datasetlist.json'
    }
    //const params = { classifier_start, classifier_end };
    const params = wrap_params_with_token({});

    const res = await axiosInstance.get(url, {params});
    if (res.status === 200) {
        return res.data;
    }
    throw res;
}

export function getRawDataURL(dataset:any="PASCAL", filename="2008_000348.jpg"){
    let url = `${URL}/api/` + `/` + dataset + "/" + filename;
    if(ENABLE_STATIC_JSON){
        url = `${URL2}/data/` + `/` + dataset + "/" + filename;
    }
    return url;
}